import React, { useState, useEffect } from "react";
import { getTimeAgo } from "../../utils/dateUtils";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  CircularProgress,
  Chip,
  Paper,
  Pagination,
  Stack,
  IconButton,
  Tooltip,
  capitalize,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
// import WorkIcon from "@mui/icons-material/Work";
// import CodeIcon from "@mui/icons-material/Code";
// import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
// import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";


// Function to update job likes on the backend
const updateJobLikeOnServer = async (jobId, action) => {
  try {
    console.log(`Updating job ${jobId} with action: ${action}`);
    if (typeof jobId === "object") {
      jobId = jobId._id || jobId.jobId || "";
    }

    const response = await fetch(`/api/jobs/${jobId}/likes`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action }), // 'like' or 'unlike'
    });

    if (!response.ok) {
      throw new Error(`Failed to update like status: ${response.status}`);
    }

    const data = await response.json();
    return data.likeCount; // Return the updated like count
  } catch (error) {
    console.error("Error updating like status:", error);
    throw error;
  }
};

const JobCard = ({ job, handleApply, onLikeUpdate }) => {
  const [liked, setLiked] = useState(false);
  const [likeCount, setLikeCount] = useState(job.like_count || 0);

  // Fetch initial like status from localStorage
  useEffect(() => {
    // Get liked status from localStorage
    const likedJobs = JSON.parse(localStorage.getItem("likedJobs") || "{}");
    setLiked(likedJobs[job.jobId || job._id] || false);

    // Use the server-provided like count initially
    setLikeCount(job.like_count || 0);
  }, [job]);

  const handleLike = async (e) => {
    e.stopPropagation();
    try {
      const jobId = job.jobId || job._id;
      const action = liked ? "unlike" : "like";

      // Update like on server
      const updatedLikeCount = await updateJobLikeOnServer(jobId, action);

      // Update local state
      setLiked(!liked);
      setLikeCount(updatedLikeCount); // FIXED: Use updatedLikeCount instead of data.likeCount

      // Save user like preference to localStorage
      const likedJobs = JSON.parse(localStorage.getItem("likedJobs") || "{}");
      likedJobs[jobId] = !liked;
      localStorage.setItem("likedJobs", JSON.stringify(likedJobs));

      if (onLikeUpdate) {
        onLikeUpdate(jobId, updatedLikeCount); // FIXED: Use updatedLikeCount instead of data.likeCount
      }
    } catch (error) {
      console.error("Failed to update like:", error);
      // Local fallback if server update fails
      const newLikeCount = liked ? Math.max(0, likeCount - 1) : likeCount + 1;

      // Update local state
      setLiked(!liked);
      setLikeCount(newLikeCount);

      // Save to localStorage
      const likedJobs = JSON.parse(localStorage.getItem("likedJobs") || "{}");
      likedJobs[job.jobId || job._id] = !liked;
      localStorage.setItem("likedJobs", JSON.stringify(likedJobs));

      if (onLikeUpdate) {
        onLikeUpdate(job.jobId || job._id, newLikeCount);
      }
    }
  };

  return (
    <Card onClick={() => handleApply(job)}
      elevation={2}
      sx={{
        height: "100%",
        display: "flex",
        borderRadius: "10px",
        transition: "all 0.3s",
        "&:hover": { transform: "translateY(-4px)", boxShadow: 6 },
        position: "relative",cursor:"pointer", boxShadow:"none", border:"solid 1px #fff", backgroundColor:"#fff"
      }}
    >
      {/* Like Button */}
      <Box
        sx={{
          position: "absolute",
          top: 12,
          right: 20,
          display: "flex",
          alignItems: "center",
          zIndex: 1,
        }}
      >
  {/* ///////Number of Job Opening */}
  {job.numberOfOpenings && job.numberOfOpenings > 0 && (
  <Typography
    variant="body2"
    color="text.secondary"
    sx={{ mb: 1, fontSize:"12px" }}
  >
    Openings: <Typography sx={{fontWeight:"600", color:"#000", fontSize:"12px", display:"inline"}}>{job.numberOfOpenings}</Typography>
  </Typography>
)}


      </Box>
      

      <CardContent
        sx={{
          flexGrow: 1,
          p: 2.5,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          pb: "16px !important",
          width: "100%",
        }}
      >
        <Box>
          <Typography
            variant="h6"
            component="h2"
            noWrap
            sx={{ fontWeight:400, fontSize: "1.1rem", textTransform:"capitalize", mb: 1.5, pr: 5 }}
          >
            {job.title}
          </Typography>
          

          <Grid container spacing={1} sx={{alignItems:"center"}}>
            <Grid item xs={12} sm={7} md={8}>
              <Stack spacing={1}>
                <Stack direction="row" spacing={1} flexWrap="wrap">
                  <Chip
                    icon={<LocationOnIcon sx={{ fontSize: "10px" }} />}
                    label={`${job.location}${job.state ? `, ${job.state}` : ''}`}
                    size="small"
                    variant="outlined"
                      sx={{fontSize:"10px", marginBottom:{xs:"4px !important", sm:"4px !important", md:"10px"}}}
                  />

                  <Chip 
                    label={job.experience}
                    size="small"
                    color="primary"
                    variant="outlined"
                    sx={{fontSize:"10px", marginBottom:{xs:"4px !important", sm:"4px !important", md:0}}}
                  />

                  <Chip 
                    label={job.skillset}
                    size="small"
                    color="secondary"
                    variant="outlined"
                    sx={{fontSize:"10px", marginBottom:{xs:"4px !important", sm:"4px !important", md:0}}}
                  />
                  <Chip 
                    label={job.jobType}
                    size="small"
                    color="info"
                    variant="outlined"
                    sx={{fontSize:"10px", marginBottom:{xs:"4px !important", sm:"4px !important", md:0}}}
                  />

                  {/* job Mode */}

                  {job.jobMode && (
                    <Chip 
                      label={job.jobMode}
                      size="small"
                      color="secondary"
                      variant="outlined"
                      sx={{fontSize:"10px", marginBottom:{xs:"4px !important", sm:"4px !important", md:0}}}
                  />
                  )}
                </Stack>
              </Stack>
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              sx={{ display:{xs:"block", sm:"block", md:"flex"}, justifyContent:{xs:0, sm:0, md:"flex-end"}}}
            >
              <Button
                variant="outlined"
                color="primary" size="small"
                sx={{
                //  py: 0.7,
                  px: 2,
                  borderRadius: "0px",
                  fontSize: "0.85rem",
                  boxShadow:0,
                  backgroundColor:"#fff",
                  fontWeight:"normal",
                  width:{xs:"100%", sm:"100%", md:"auto"}
                }}
              >
                Apply
              </Button>
            </Grid>
            
          <Typography sx={{fontSize:"12px", position:"relative", bottom:"-2px", left:"10px", marginTop:"10px", color:"#787878"}}>
            {getTimeAgo(job.createdAt)}
          </Typography>
          </Grid>
        </Box>
      </CardContent>
    </Card>
  );
};

const JobListingSection = ({
  jobs,
  handleApply,
  currentPage,
  totalPages,
  handlePageChange,
  onRefreshNeeded,
}) => {
  const [updatedJobs, setUpdatedJobs] = useState({});

  const handleLikeUpdate = (jobId, newLikeCount) => {
    setUpdatedJobs((prev) => ({
      ...prev,
      [jobId]: newLikeCount,
    }));

    if (onRefreshNeeded) {
      onRefreshNeeded();
    }
  };

  const getLikeCount = (job) => {
    const jobId = job.jobId || job._id;
    return updatedJobs[jobId] !== undefined
      ? updatedJobs[jobId]
      : job.like_count || 0;
  };

  return (
    <>
      <Grid container spacing={3}>
        {jobs.length > 0 ? (
          jobs.map((job) => (
            <Grid item xs={12} key={job.jobId || job._id}>
              <JobCard
                job={{ ...job, like_count: getLikeCount(job) }}
                handleApply={handleApply}
                onLikeUpdate={handleLikeUpdate}
              />
            </Grid>
          ))
        ) : (
          <Grid item xs={12}>
            <Paper
              elevation={2}
              sx={{ p: 4, textAlign: "center", borderRadius: "10px" }}
            >
               <Box sx={{ display: 'flex', justifyContent:'center', marginBottom:'16px' }}> <CircularProgress /> </Box>
              <Typography variant="h6" color="textSecondary" sx={{fontWeight:'normal', fontSize:'14px'}}>Please wait... </Typography>
            </Paper>
          </Grid>
        )}
      </Grid>

      

      {/* Fixed Pagination */}
      {jobs.length > 0 && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 4,
            mb: 2,
            overflowX: "auto",
          }}
        >
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={(e, value) => handlePageChange(value)}
            color="primary"
            shape="rounded"
            size="large"
          />
        </Box>
      )}
    </>
  );
};

export default JobListingSection;
